/** The instance admin index. */
export const admin = {
  notFound: 'Not found',
  notFoundBody: 'This page does not exist for this account.',
  back: 'Back',
  instance: 'Instance',
  canvases: 'Canvases',
  accounts: 'Accounts',
  breadcrumb: 'Breadcrumb',
  home: 'Home',
  admin: 'Admin',
  searchCanvasesPlaceholder: 'Search canvases or owners…',
  searchAccountsPlaceholder: 'Search accounts…',
  searchCanvases: 'Search canvases or owners',
  searchAccounts: 'Search accounts',
  title: 'Everything on this instance',
  accountCount: { one: '{count} account', other: '{count} accounts' },
  canvasCount: { one: '{count} canvas', other: '{count} canvases' },
  frameCount: { one: '{count} frame', other: '{count} frames' },
  canvasesTab: 'Canvases · {count}',
  accountsTab: 'Accounts · {count}',
  showingRecent: 'Showing the {shown} most recently updated of {total}',
  linkAccessView: 'Anyone with the link can view this canvas',
  linkAccessComment: 'Anyone with the link can comment this canvas',
  linkAccessEdit: 'Anyone with the link can edit this canvas',
  linkView: 'link: view',
  linkComment: 'link: comment',
  linkEdit: 'link: edit',
  unclaimed: 'unclaimed',
  invited: '{count} invited',
  viewAsName: 'View as {name}',
  roleAdmin: 'admin',
  banned: 'banned',
  joined: 'joined {time}',
  viewAs: 'View as',
  unban: 'Unban',
  ban: 'Ban',
  banTitle: 'Ban {name} ({email})?',
  unbanTitle: 'Unban {name} ({email})?',
  banDescription: 'They are signed out everywhere and cannot sign in or use MCP until unbanned.',
} as const
